import React from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../constants/GlobalStyles';
import NewUserForm from '../components/users/NewUserForm';
import { patientFormType } from '../components/config/variables';

const UpdatePatient = () => {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
    >
      <NewUserForm type={patientFormType.update}/>
    </motion.div>
  );
};

export default UpdatePatient;
